"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const common_1 = require("@Const/common");
const HelpDeskQuestionForm = () => (react_1.default.createElement("div", { className: 'contact-us-form-wrapper' },
    react_1.default.createElement("img", { src: common_1.ICONS.email }),
    react_1.default.createElement("div", { id: "hubspotForm" })));
exports.default = HelpDeskQuestionForm;
